<div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Dashboard</span>
  </div>
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <a class="addCursor float-right downloadBtn" (click)="downloadExcel()">Download Lead</a>
    <button class="addCursor float-right downloadBtn mr-2" type="button" data-toggle="modal" data-target="#addNewLeadModal">Add Lead</button>
  </div>
</div>
<div class="row">
  <div class="col-12" *ngIf="erroralert">
    <div class="alert-box grid-100" *ngIf="errorMessage">
      <div class="alert alert-danger mt-3 text-center">
        <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
        {{errorMessage}}
      </div>
    </div>
  </div>
  <div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMessage">
      <div class="alert alert-success mt-3 text-center">
        <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
        {{successMessage}}
      </div>
    </div>
  </div>
</div>

<div class="row p-3">
  <div class="col-md-12 pt-3 pb-3 bg-white">
    <div class="row">
      <div class="col-md-4 pt-3">
        <span class="theme-font">Lead Status by Count</span>
      </div>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-4 mt-1">
            <select class="form-control mt-3 ml-3 col-sm-5" (change)="filterColumDropdownChange($event.target.value)" [(ngModel)]="filtercol1Val" id="filter1dropdown">
              <option value="all" selected><span class="capitalize">All</span></option>
              <option value="lead_created_at"><span class="capitalize">Lead Acquisition Date</span></option>
              <option value="assigned_to_cm"><span class="capitalize">CM Assignment Date</span></option>
              <option value="assigned_to_designer"><span class="capitalize">Designer Assignment Date</span></option>
            </select>
            
          </div>
          <div class="col-md-3 d-none" id="from_date_div">
            <span>From:</span>
            <input type="date" name="from_date" class="form-control from_date ss-date" id="from_date" (change)="changeDateFrom($event.target.value)">
            
          </div>
          <div class="col-md-3 d-none " id="to_date_div">
            <span>To:</span>
            <input type="date" name="to_date" class="form-control to_date ss-date" id="to_date" (change)="changeDateTo($event.target.value)" min = {{date_from}}>
          </div>
          <div class="col-md-2 text-center cursor-pointer destopSubmitDiv" (click)="filterDashboard()" >
            <img src="./assets/img/dashboard/submit.png" style="margin-top: 20px;" class="pt-3 destopSubmit">
            <button class="button mobSubmit" style="margin-top: 10px;">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="row">

</div> -->
<div class="row my-4">
  <div class="col-sm-12 col-md-6 col-lg-4 mb-lg-3 mb-sm-2">
    <div class="ss-card p-4 cursor-pointer" [routerLink]="['/designer/leads']" routerLinkActive="active" [queryParams]="{customer_status: 'qualified',column_name:SelectedValue,from_date: date_from ,to_date: date_to}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4" >
          QUALIFIED & ASSIGNED
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5" *ngIf="statusCountArr">
        <span class="h1">{{statusCountArr.qualified || 0}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> The number of count shows that what number of leads are assigned by the community manager.</span>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-6 col-lg-4 mb-lg-3 mb-sm-2">
    <div class="ss-card p-4 cursor-pointer" [routerLink]="['/designer/leads']" routerLinkActive="active" [queryParams]="{customer_status: 'lost',column_name:SelectedValue,from_date: date_from ,to_date: date_to}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/lost.png">
        </span>
        <span class="theme-font ml-4">
          LOST
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5" *ngIf="statusCountArr">
        <span class="h1" style="color: #FF0018;">{{statusCountArr.lost || 0}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> The number of count shows the leads which cannot be further pursued.</span>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-6 col-lg-4 mb-lg-3 mb-sm-2">
    <div class="ss-card p-4 cursor-pointer" [routerLink]="['/designer/leads']" routerLinkActive="active"  [queryParams]="{customer_status: 'follow_up',column_name:SelectedValue,from_date: date_from ,to_date: date_to}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/follow_up.png">
        </span>
        <span class="theme-font ml-4">
          FOLLOW-UP
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5" *ngIf="statusCountArr">
        <span class="h1">{{statusCountArr.follow_up || 0}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> The number of count shows that how many leads needed to be followed up on.</span>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-6 col-lg-4 mb-lg-3 mb-sm-2">
    <div class="ss-card p-4 cursor-pointer" [routerLink]="['/designer/leads']" routerLinkActive="active"  [queryParams]="{customer_status: 'not_contactable',column_name:SelectedValue,from_date: date_from ,to_date: date_to}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/not_contactable.png">
        </span>
        <span class="theme-font ml-4">
          NOT CONTACTABLE
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5" *ngIf="statusCountArr">
        <span class="h1">{{statusCountArr.not_contactable || 0}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> The number of count shows the data of the leads that are not contactable for some reasons.</span>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-6 col-lg-4 mb-lg-3 mb-sm-2">
    <div class="ss-card p-4 cursor-pointer" id="wipbox-activator" (click) = "showWip()">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/wip.png">
        </span>
        <span class="theme-font ml-4">
          WORK IN PROGRESS
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5" *ngIf="statusCountArr">
        <span class="h1">{{statusCountArr.after_wip || 0}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> The number of count shows the leads which are in work in progress but no design is submitted.</span>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-6 col-lg-4 mb-lg-3 mb-sm-2">
    <div class="ss-card p-4 cursor-pointer">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/wip.png">
        </span>
        <span class="theme-font ml-4">
          HANDOVER
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5" *ngIf="statusCountArr">
        <span class="h1">{{statusCountArr.handover || 0}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> This count shows that project is completed and full payment is received.</span>
      </div>
    </div>
  </div>

</div>

<div class="row p-3" id="wip-box">
  <div class="col-md-12 bg-white pt-3 pb-3">
    <div class="row">
      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              WIP
            </span>
            <span class="dashboard-count" *ngIf="statusCountArr">{{statusCountArr.wip || 0}}</span>
          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> This count shows that how many leads are in wip.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              PRE 10%
            </span>
            <span class="dashboard-count" *ngIf="statusCountArr">{{statusCountArr.pre_10_percent || 0}}</span>
          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> This count shows that the initial design is submitted to the lead.</span>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              10% - 50%
            </span>

            <span class="dashboard-count" *ngIf="statusCountArr">{{statusCountArr['10_50_percent'] || 0}}</span>
          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> This count shows that payment has been done for the first 10% of work.</span>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              50%
            </span>
            <span class="dashboard-count" *ngIf="statusCountArr">{{statusCountArr['50_percent'] || 0}}</span>

          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> This count shows that payment has been done for 40% of work.</span>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              INSTALLATION
            </span>
            <span class="dashboard-count" *ngIf="statusCountArr">{{statusCountArr.installation || 0}}</span>
          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> This count shows that payment is done for 50% of work and production is in progress.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              INACTIVE
            </span>
            <span class="dashboard-count" *ngIf="statusCountArr">{{statusCountArr.inactive || 0}}</span>
          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> This count shows that how many leads are INACTIVE.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              ON HOLD
            </span>
            <span class="dashboard-count" *ngIf="statusCountArr">{{statusCountArr.on_hold || 0}}</span>
          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> This count shows that how many leads are put on hold.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add lead modal -->
<div class="modal fade customModal" id="addNewLeadModal" tabindex="-1" role="dialog" aria-labelledby="addNewLeadModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <form (ngSubmit)="addLeadFormSubmit(addLeadForm.value); " [formGroup]="addLeadForm" class="form-horizontal" enctype="multipart/form-data" id="addLeadForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title modalTitle" id="exampleModalLabel"> Lead Details</h5>
        </div>
        <div class="modal-body">
          <div class="row mx-2">
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Name </label>
                <input type="text" class="form-control" name="name" placeholder="Enter Lead Name" formControlName="name">
              </div>
            </div>
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Lead Email</label>
                <input type="text" class="form-control" name="email" placeholder="Enter Lead Email" formControlName="email">
                <div *ngIf="addLeadForm.controls['email'].errors && !addLeadForm.controls['email'].pristine" class="text-danger">

                  <div [hidden]="addLeadForm.controls['email'].valid">Enter valid email.</div>
                </div>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Lead Contact <span>*</span></label>
                <input type="number" class="form-control" name="contact" placeholder="Enter Lead Contact" formControlName="contact" required min="0" (keydown)="numberCheck($event)">
                <div *ngIf="addLeadForm.controls['contact'].errors && !addLeadForm.controls['contact'].pristine" class="text-danger">
                  <div [hidden]="!addLeadForm.controls['contact'].errors.required">Contact is required.</div>
                </div>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Pincode</label>
                <input type="number" class="form-control" name="pincode" placeholder="Enter Lead Pincode" formControlName="pincode" min="0" (keydown)="numberCheck($event)">
              </div>
            </div>

            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Select Lead Type <span>*</span></label>
                <select formControlName="lead_type_id" class="form-control capitalize" (change)="showLeadStatusDropdown($event.target.value); onChangeOfLeadType($event.target.value)">
                  <option value="" disabled>Select</option>
                  <!-- <option value="1" >customer</option> -->
                  <option value="{{type.id}}" *ngFor="let type of add_lead_types">{{type.name}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Select Lead Source <span>*</span></label>
                <select formControlName="lead_source_id" class="form-control capitalize">
                  <option value="" disabled>Select</option>
                  <option value="{{src.id}}" *ngFor="let src of lead_sources">{{src.name | replaceChar}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Select Lead Campaign </label>
                <select formControlName="lead_campaign_id" class="form-control capitalize">
                  <option value="" disabled>Select</option>
                  <option value="{{camp.id}}" *ngFor="let camp of lead_campaigns">{{camp.name | replaceChar}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 d-none" id="addLeadStatusDropdown">
              <div class="form-group">
                <label class="text-left">Select Lead Status </label>
                <select formControlName="lead_status" class="form-control capitalize" (change)="setLeadStatus1($event.target.value)">
                  <option value="" disabled>Select</option>
                  <option value="qualified">Qualified</option>
                  <option value="follow_up">Follow Up</option>
                  <option value="lost">Lost</option>
                  <option value="not_contactable">Not Contactable</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6" *ngIf="addLeadForm.controls['lead_type_name'].value=='designer'">
              <div class="form-group">
                <label class="text-left">Instagram Id </label>
                <input type="text" formControlName="instagram_handle" name="" class="form-control">
              </div>
            </div>
            <div class="col-sm-10 col-md-6" *ngIf="addLeadForm.controls['lead_type_name'].value=='designer'">
              <div class="form-group">
                <label class="text-left">Upload CV </label>
                <input type="file" name="" class="form-control" (change)="uploadCV($event)" name="attachment_file">
              </div>
            </div>
            <div class="col-md-6" id="addleadFormdatetime" style="display: none;">
              <div class="form-group">
                <label class="text-left">Follow up Time</label>
                <input type="datetime-local" formControlName="follow_up_time" name="" class="form-control">
              </div>
            </div>
            <div class="col-md-6" id="addleadFormRemark" style="display: none;">
              <div class="form-group">
                <label class="text-left">Follow up Remark</label>
                <input type="text" formControlName="remark" name="" class="form-control">
              </div>
            </div>
            <div class="col-md-6" id="addleadFormlostReason" style="display: none;">
              <div class="form-group">
                <label for="example-text-input" class="text-left">Reason for Lost <span class="text-danger">*</span></label>
                <div class="">
                  <select class="form-control" id="lost_reason" formControlName="lost_reason" (change)="reasonForLostDropdownChange($event.target.value)">
                    <option value="" disabled>Select Reason</option>
                    <option *ngFor="let reason of lostReasonsArr" value="{{reason}}">{{reason | replaceChar}}</option>
                  </select>
                  </div>
              </div>
            </div>  
            <div class="col-md-6"  id="addleadFormlostremark" style="display: none;">
              <div  class="form-group">
                <label >Remarks</label>
                <textarea class="form-control" rows="2" formControlName="lost_remark"></textarea>
              </div>
            </div>
            <div class="col-sm-12 mt-3 text-right">
              <div class="mt-3">
              <button type="submit" [disabled]="!addLeadForm.valid" class="rk-interalBtnColor addCursor">Add</button>
              <button class="cancle ml-3 addCursor rk-btnCancel" data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="addleadquestionnaire" (ngSubmit)="addLeadQuestionnaire(addleadquestionnaire.value);" id="addleadquestionnaireForm" style="display: none;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title modalTitle" id="exampleModalLabel">Lead Questionnaire</h5>
        </div>
        <div class="modal-body addleadQuestionnaireModal">
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="row mx-1 mb-4 mt-2 row1">
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label class="customLabel">Project Name</label>
                    <input type="text" class="form-control" placeholder="Your answer" formControlName="project_name">
                  </div>
                </div>
                <div class="col-sm-10 col-md-3">
                  <label class="customLabel">Call Back Day 
                    <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                  </label>
                  <div class="form-check">
                    <input type="date" name="" formControlName="call_back_day" class="form-control">
                  </div>
                </div>

                <div class="col-sm-6 col-md-3">
                  <label class="customLabel">Call Back Time 
                    <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                  </label>
                  <div class="form-check">
                    <select formControlName="call_back_time" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="{{cb}}" *ngFor="let cb of callbacktime">{{cb}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label class="customLabel">Location 
                      <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                    </label>
                    <input type="text" class="form-control" placeholder="Your answer" formControlName="location">
                  </div>
                </div>
              </div>
              <div class="row row2 mx-1">
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label class="customLabel">Society/Building Name
                      <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                     </label>
                    <input type="text" class="form-control" placeholder="Your answer" formControlName="society">
                  </div>
                </div>
                <div class="col-sm-10 col-md-12 mt-3">
                  <label class="customLabel">City 
                    <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                  </label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4 capitalize" *ngFor="let city of citiesForQuestionnaire;">
                      <input class="form-check-input capitalize" type="radio" value="{{city.name}}" formControlName="city" (change)="onchangeCity1(city.name)">
                      {{city.name | replaceChar}}
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Other" formControlName="city" (change)="onchangeCity1('Other')">
                      Other <input type="text" name="city_others" class="ml-2" class="form-control d-none" style="margin-top: -10px; width: 72%;display: inline-block;border-color: red;" [(ngModel)]="city_others" [ngModelOptions]="{standalone: true}" id="cityOthersInput1">
                    </label>
                  </div>
                </div>


                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Project Type 
                    <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                  </label>
                  <div class="form-check">
                    <label class="form-check-label mr-4 lableSize labelColor mb-2">
                      <input class="form-check-input" type="radio" value="Residential" formControlName="project_type">
                      Residential
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Offices" formControlName="project_type">
                      Offices
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Type of Accommodation 
                    <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                  </label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mr-4" *ngFor="let at of accommodation_type">
                      <input class="form-check-input" type="radio" value="{{at}}" formControlName="accomodation_type">
                      {{at}}
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Type of Home 
                    <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                  </label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="New (No one has ever stayed in that home)" formControlName="home_type">
                      New (No one has ever stayed in that home)
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Old (Currently staying in the house)" formControlName="home_type">
                      Old (Currently staying in the house)
                    </label>
                  </div>
                </div>
                <div class="col-sm-10 col-md-12 mt-3">
                  <label class="customLabel">Possession status 
                    <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                  </label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Possession Taken" formControlName="possession_status" (click)="possesionStatusSelected('Possession Taken','addleadQuestionnaire')">
                      Possession Taken
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Awaiting Possession" formControlName="possession_status" (click)="possesionStatusSelected('Awaiting Possession','addleadQuestionnaire')">
                      Awaiting Possession (If Yes, please fill the date of possession below on "other")
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-5 mt-3" id="possesionadd_date" style="display:none;">
                  <label class="customLabel">Estimated month of Possession 
                    <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                  </label>
                  <select formControlName="possession_status_date" class="form-control">
                    <option value="" disabled>Choose</option>
                    <option value="{{est}}" *ngFor="let est of estimatedPossessionTime">{{est}}</option>
                  </select>
                </div>
                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Scope of work 
                    <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                  </label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4" *ngFor="let sw of scopeOfwork">
                      <!-- <input type="checkbox" class="form-check-input" value="{{sw}}" (change)="onCheckChange($event,'scope_of_work')"> -->
                      <input type="radio" class="form-check-input" value="{{sw}}" formControlName="scope_of_work">
                      {{sw}}
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Do you have a home loan against the property? 
                    <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                  </label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Yes" formControlName="have_homeloan">
                      Yes
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="No" formControlName="have_homeloan">
                      No
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Doesn't want to disclose" formControlName="have_homeloan">
                      Doesn't want to disclose
                    </label>
                  </div>
                </div>

                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Do you have a floor plan? </label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Yes" formControlName="have_floorplan" (click)="fpQuestionnaireSelected('yes','floorplanQuestionnaire')">
                      Yes
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="No" formControlName="have_floorplan" (click)="fpQuestionnaireSelected('no','floorplanQuestionnaire')">
                      No
                    </label>
                  </div>
                </div>

                <div class="col-sm-12 col-md-12 mt-3" id="floorplanQuestionnaire" style="display: none;">
                  <label class="customLabel">Upload Floorplan</label>
                  <div class="form-check">
                    <input class="form-control" type="file" (change)="onQuestionnaireFloorplanChange($event)" name="floorplan_attachment_file" ngModel #floorplan_attachment_file="ngModel" [ngModelOptions]="{standalone: true}">
                  </div>
                  <p id="extErrorMsg" class="text-danger d-none col-sm-10">Check File extension (File should be in proper image format).</p>
                  <p class="col-sm-10">Note* - only image files are allowed.  </p>
                </div>

                <div class="col-sm-10 col-md-5 mt-3">
                  <div class="form-group">
                    <label class="customLabel">Home Value(In Rs Lacs)
                      <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                    </label>
                    <select formControlName="home_value" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="Less than 30 Lacs">Less than 30 Lacs</option>
                      <option value="30 - 50 Lacs">30 - 50 Lacs</option>
                      <option value="50 - 70 Lacs">50 - 70 Lacs</option>
                      <option value="70 - 99 Lacs">70 - 99 Lacs</option>
                      <option value="1 - 1.25 Cr">1 - 1.25 Cr</option>
                      <option value="1.26 - 1.75 Cr">1.26 - 1.75 Cr</option>
                      <option value="1.76 - 2.50 Cr">1.76 - 2.50 Cr</option>
                      <option value="Above 2.50 Cr">Above 2.50 Cr</option>
                      <option value="Not Available">Not Available </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-3">
                  <div class="form-group">
                    <label class="customLabel">Budget Value(In Rs Lacs)
                      <!-- <span class="hideAsteriskIcon text-danger">*</span> -->
                    </label>
                    <select formControlName="budget_value" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="Less than 1.5 Lac">Less than 1.5 Lac</option>
                      <option value="1.5 - 3 Lacs">1.5 - 3 Lacs</option>
                      <option value="3 - 5 Lacs">3 - 5 Lacs</option>
                      <option value="5 - 8 Lacs">5 - 8 Lacs</option>
                      <option value="8 - 12 Lacs">8 - 12 Lacs</option>
                      <option value="Above 12 Lacs">Above 12 Lacs</option>
                      <option value="Not Disclosed">Not Disclosed</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-3">
                  <div class="form-group">
                    <label class="customLabel">Lead Generator</label>
                    <select formControlName="lead_generator" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="Akshay Pawar">Akshay Pawar</option>
                      <option value="Azhar Khan">Azhar Khan</option>
                      <option value="Rohit Dalvi">Rohit Dalvi</option>
                      <option value="Roshni Malik">Roshni Malik</option>
                      <option value="Roshan">Roshan</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-3">
                  <div class="form-group">
                    <label class="customLabel">Lead Source</label>
                    <select formControlName="lead_source" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="Facebook Campaign">Facebook Campaign</option>
                      <option value="Inbound Call">Inbound Call</option>
                      <option value="Housing Finance">Housing Finance</option>
                      <option value="Facebook Direct">Facebook Direct</option>
                      <option value="Get a callback from us">Get a callback from us</option>
                      <option value="Broker">Broker</option>
                      <option value="Referral">Referral</option>
                      <option value="Dealer">Dealer</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-4">
                  <label class="customLabel">Additional Comments</label>
                  <div class="form-check">
                    <textarea rows="2" class="form-control" formControlName="additional_comments"></textarea>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-4">
                  <label class="customLabel">Change Status <span class="text-danger">*</span></label>
                  <div class="form-check">
                    <select class="form-control" formControlName="lead_status" (change)="setLeadStatus2($event.target.value)">
                      <option value="" disabled>Select Status</option>
                      <option value="qualified">Qualified</option>
                      <!-- <option value="follow_up">Follow Up</option>
                      <option value="lost">Lost</option>
                      <option value="not_contactable">Not Contactable</option> -->
                    </select>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-4" id="addleadQuestFollowuptime" style="display: none">
                  <label class="customLabel">Followup Time <span class="text-danger">*</span></label>
                  <div class="form-check">
                    <input class="form-control" type="datetime-local" formControlName="follow_up_time">
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-4" id="addleadQuestRemark" style="display: none">
                  <label class="customLabel">Followup remark <span class="text-danger">*</span></label>
                  <div class="form-check">
                    <input class="form-control" type="text" formControlName="remark">
                  </div>
                </div>
                <div class="col-md-6" id="addleadQuestLostReason" style="display: none;">
                  <div class="form-group">
                    <label for="example-text-input" class="text-left">Reason for Lost <span class="text-danger">*</span></label>
                    <div class="">
                      <select class="form-control" id="lost_reason" formControlName="lost_reason" (change)="reasonForLostDropdownChange1($event.target.value)">
                        <option value="" disabled>Select Reason</option>
                        <option *ngFor="let reason of lostReasonsArr" value="{{reason}}">{{reason | replaceChar}}</option>
                      </select>
                      </div>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5" id="addleadFormquestremark" style="display: none">
                  <label class="customLabel">Remarks</label>
                  <div class="form-check">
                    <textarea class="form-control" rows="2" formControlName="lost_remark"></textarea>
                  </div>
                </div>
                <!-- <pre>{{addleadquestionnaire.value | json }}</pre> -->
                <div class="col-sm-12 col-md-12 text-right">
                    <button type="submit" class="mt-4 rk-interalBtnColor addCursor " [disabled]="!addleadquestionnaire.valid || (addleadquestionnaire.valid && addleadquestionnaire.controls['city'].value=='Other' && (city_others=='' ||city_others==undefined))">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/designer/dashboard/dashboard.component.html